import { css, type Theme } from '@emotion/react';

export const container = ({ hasStatus }: { hasStatus: boolean }) => css`
  display: flex;
  align-items: ${hasStatus ? 'start' : 'center'};
  gap: 8px;
`;

export const textContainer = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  word-break: break-word;
`;

export const fullNameText = (theme: Theme) => css`
  &.isLight {
    color: ${theme.colors.gray[0]};
  }

  color: ${theme.colors.gray[900]};  
`;

export const statusText = (theme: Theme) => css`
  color: ${theme.colors.gray[700]};
`;
